import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';


export const CREATE_BULK_DEMAND_PTL = createRequestTypes('CREATE_BULK_DEMAND_PTL');

export const createBulkDemandPTL = {
  request: (payload) => createAction(CREATE_BULK_DEMAND_PTL[REQUEST], { payload }),
  success: (response) => createAction(CREATE_BULK_DEMAND_PTL[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_BULK_DEMAND_PTL[FAILURE], { response }),
};

